import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";

/**
 * Initializes the announcement swiper specifically for the Default Top Bar.
 */
export const initDefaultTopBarSwiper = (): void => {
  // Guard Clause: Only run if the default top bar is present
  const topBar = document.querySelector<HTMLElement>(".top-bar--default");
  if (!topBar) {
    return;
  }

  const swiperElement = topBar.querySelector<HTMLElement>(".top-bar-swiper");

  if (!swiperElement) {
    return;
  }

  new Swiper(swiperElement, {
    modules: [Autoplay],
    direction: "vertical",
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    allowTouchMove: false, // Users shouldn't be able to swipe this
  });

  console.log("[Swiper] Default Top bar announcement swiper initialized.");
};
